import { User } from "@app/core/model/user/user.model";
import { createAction, props } from "@ngrx/store";

export const SET_USER_DATA = createAction(
    '[User] Load User Data',
    props<User>()
  );

  export const LOAD_USER_DATA = createAction(
    '[User] Login'
  );